import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import type { Constructor } from '@whispli/types';

export class __Declarant extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  /**
   * @deprecated For backwards-compatibility only. Use firstName
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private first_name!: string | null;

  @Expose({groups: ['client']})
  public get firstName() {
    return this.first_name
  }

  public set firstName(value) {
    this.first_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use lastName
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private last_name!: string | null;

  @Expose({groups: ['client']})
  public get lastName() {
    return this.last_name
  }

  public set lastName(value) {
    this.last_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use nameExists
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private name_exists?: boolean;

  @Expose({groups: ['client']})
  public get nameExists() {
    return this.name_exists
  }

  public set nameExists(value) {
    this.name_exists = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly email!: string | null;
}

interface OptionalAlias {
  nameExists?: boolean | undefined;
}
export type Declarant = Omit<__Declarant, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'first_name' | 'last_name' | 'name_exists' | 'nameExists'> & OptionalAlias
export const Declarant = __Declarant as any as Constructor<Declarant>
